export default __webpack_public_path__ + "static/media/home-shape-2-45ee2697b879b410f36107f5fc7773ee.1b3e11be.png";